import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import { AI_ASSISTANT_BLUE } from "./constants";

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
`;

export default function AITypingIndicator() {
  return (
    <Box
      aria-label="Assistant is typing"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        px: 1.6,
        py: 1.2,
        borderRadius: "16px 16px 16px 4px",
        bgcolor: "#f1f5f9",
        border: "1px solid rgba(148,163,184,0.25)",
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            bgcolor: AI_ASSISTANT_BLUE,
            animation: `${bounce} 1.2s ease-in-out ${i * 0.16}s infinite`,
          }}
        />
      ))}
    </Box>
  );
}
